import { Grid2, useTheme } from '@mui/material';
import { PosterImage } from '#components/PosterImage/index.tsx';
import { Tile } from '#components/Tile/index.tsx';
import { type TileItem } from '#components/Tile/types.ts';

export type ResultsProps = {
  items: TileItem[];
};

export const Results = ({ items }: ResultsProps) => {
  const theme = useTheme();

  return (
    <Grid2 container spacing={0}>
      {items.map(({ id, type, ...rest }, index) => {
        return (
          <Grid2 key={`${String(id)}-${String(index)}`} size={{ md: 6, xs: 12 }} sx={{ padding: theme.spacing(1.5) }}>
            <Tile
              {...rest}
              id={id}
              orientation="horizontal"
              renderImage={imageProps => (
                <PosterImage
                  {...imageProps}
                  showMoreOptions={false}
                  sx={{ flexShrink: 0, width: '100px', [theme.breakpoints.up('md')]: { width: '125px' } }}
                />
              )}
              type={type}
            />
          </Grid2>
        );
      })}
    </Grid2>
  );
};
